import styled from 'styled-components'

export const Container = styled.div`
  background-color: #00659c;
  width: 15%;
  padding: 20px;
  font-size: 14px;
`
export const SubMenu = styled.div`
  display: ${props => (props && props.isOpen ? 'block' : 'block')};
  padding: 3px 10px;
`
